import React  from "react";
import { useGLTF } from "@react-three/drei";

export function PalletRack1P1S(props) {
  const { nodes, materials } = useGLTF("/new_models/pr_1x_1y.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Cube002.geometry}
        material={materials["Material.008"]}
      />
    </group>
  );
}

useGLTF.preload("/new_models/pr_1x_1y.glb");

export default PalletRack1P1S;
